import { useEffect, useState } from "react";

export default function MediumBand() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      const isNearBottom = scrollY + windowHeight >= docHeight - 120;

      if (scrollY > 700 && !isNearBottom) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const openMedium = () => {
    window.open("https://medium.com/@ashubhai", "_blank");
  };

  return (
    <div
      onClick={openMedium}
      style={{
        position: "fixed",
        bottom: "28px",
        left: "50%",
        transform: visible ? "translate(-50%, 0)" : "translate(-50%, 20px)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transition: "all 0.4s ease",
        zIndex: 9999,
        cursor: "pointer",
        fontFamily: "JetBrains Mono, monospace",
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #060606ff, #0f172a)",
          border: "1px solid rgba(8, 9, 9, 0.45)",
          borderRadius: "12px",
          padding: "14px 18px",
          color: "#e5e7eb",
          minWidth: "240px",
          textAlign: "center",
          boxShadow: "0 0 28px rgba(34, 211, 238, 0.21)",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "0 0 45px rgba(34, 211, 238, 0.6)";
          e.currentTarget.style.transform = "translateY(-3px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "0 0 28px rgba(34, 211, 238, 0.21)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <div
          style={{
            fontSize: "11px",
            color: "#22d3ee",
            marginBottom: "6px",
            opacity: 0.9,
          }}
        >
          $ medium --open
        </div>

        <div
          style={{
            fontSize: "15px",
            fontWeight: 600,
            letterSpacing: "0.4px",
          }}
        >
          Read My Articles
        </div>

        <div
          style={{
            fontSize: "11px",
            color: "#9ca3af",
            marginTop: "6px",
          }}
        >
          STATUS: PUBLISHED ▮
        </div>
      </div>
    </div>
  );
}
